import React from 'react'
import {Button, Intent, Tag} from '@blueprintjs/core'


export default function SiteHeaderLoginStatusPop({global, dispatch}) {

  function handleSignOutClick() {
    dispatch({
      type: 'UI_LOGOUT',
      data: {},
    })
  }

  return (
    <div
      style={{
        backgroundColor: '#f5f8fa',
        color: '#282828',
        padding: '1em',
        minWidth: '20em',
        borderRadius: '8px',
      }}
    >
      <div
        style={{
          //
        }}
      >
        <div
          style={{
            fontSize: '1.08em',
            fontWeight: '600',
          }}
        >
          {global.current_user_email}
        </div>

        <Tag className='mono'>
          {global.current_user_vuid}
        </Tag>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
        }}
      >
        <Button
          onClick={handleSignOutClick}
          text='Sign Out'
          icon='log-out'
          minimal={false}
          small={false}
          outlined={false}
          intent={Intent.DANGER}
        />
      </div>
    </div>
  )
}
